function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M96.644,371.392c48.62-4.463,84.544-47.65,80.081-96.269c-4.464-48.629-47.65-84.549-96.27-80.086 c-48.629,4.464-84.545,47.645-80.081,96.274C4.838,339.936,48.025,375.855,96.644,371.392z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M402.388,80.452c-4.464-48.624-47.64-84.54-96.264-80.077s-84.545,47.64-80.081,96.265 s47.645,84.545,96.269,80.081C370.936,172.257,406.851,129.076,402.388,80.452z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#47294d",
  d: "M352.926,510.231c48.624-4.464,84.54-47.645,80.076-96.269c-4.464-48.624-47.64-84.545-96.265-80.082 c-48.624,4.464-84.545,47.645-80.081,96.269C261.121,478.774,304.316,514.693,352.926,510.231z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 19,
    viewBox: "0 0 433.378 510.606"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/icon-all-stores.34843f58.svg";
export { SvgComponent as ReactComponent };